import * as types from "./mutation-type";
import { getAdminStoresQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";

const actions = {
  async getAdminStores({ commit }, variables = {}) {
    try {
      commit(types.GET_ADMIN_STORES_BEGIN);
      const {
        data: {
          data   
        }
      } = await gqlClient.query({
        query     : getAdminStoresQuery,
        variables : variables
      });
      commit(types.GET_ADMIN_STORES_SUCCESS, data.system.stores);
    } catch (e) {
      commit(types.GET_ADMIN_STORES_ERROR, e);
    }
  }
};

export default actions;
